import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { TariffDirection } from '../../../api/Optimise';
import { min } from '../../../utils/breakpoints';
import { addRateCategoriesToRecords, extractRates } from '../../../utils/savingsUtils';
import TariffRateTable from '../../TariffRateTable';

const StyledContainer = styled.div`
  margin-top: 24px;
  width: 100%;
  border-radius: 8px;
  padding: 20px;
  background-image: ${(props) => props.theme.standardLayout.savings.tariffKeyTable.backgroundImage};
  background-color: ${(props) => props.theme.standardLayout.savings.tariffKeyTable.backgroundColor};
`;

const StyledTitle = styled.h3`
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
  letter-spacing: 1.5px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const StyledTableContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
`;

const TariffKey = ({ savingsChartData }) => {
  const [rates, setRates] = useState(null);

  useEffect(() => {
    if (savingsChartData) {
      const dataWithImportCategories = addRateCategoriesToRecords(savingsChartData, TariffDirection.IMPORT);
      const dataWithExportCategories = addRateCategoriesToRecords(dataWithImportCategories, TariffDirection.EXPORT);
      const rates = extractRates(dataWithExportCategories);

      setRates(rates);
    }
  }, [savingsChartData]);

  return (
    <StyledContainer>
      <StyledTitle>Tariff Rates Explained</StyledTitle>
      <StyledTableContainer>
        <TariffRateTable rates={rates} />
      </StyledTableContainer>
    </StyledContainer>
  );
};

export default TariffKey;
